import { CryptJsSettingsInRegisterFav } from './../../../constant/crypt-js-settings';
import { CryptJsManager } from './../../share/crypt-js/crypt-js-manager';
import { UtilService } from './../../share/util/util.service';
import { AuthenticateService } from './../../share/authenticate/authenticate.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { RegisterFavService } from './register-fav.service';
declare var $;

@Component({
  selector: 'app-register-fav',
  templateUrl: './register-fav.component.html',
  styleUrls: ['./register-fav.component.scss']
})
export class RegisterFavComponent implements OnInit {

  isLoading = true;
  autoInput = {
    username: null,
    password: null,
  };

  constructor(
    private route: ActivatedRoute,
    private authServ: AuthenticateService,
    private utilServ: UtilService,
    private reqApi: RegisterFavService,
  ) { }

  ngOnInit() {
    // クエリパラメータを取得し、自動サインインを実施。
    this.route.queryParams.subscribe(
      async params => {
        const password = await this.getPasswordAsync();

        // お気に入り登録してもらう為、ブラウザのURLを自動サインイン専用ページへのURLに置き換える。
        history.replaceState('', '', `${location.protocol}//${location.host}/favorite-signin?u=${this.authServ.username}&c=${CryptJsManager.encrypt(password, CryptJsSettingsInRegisterFav.KEY, CryptJsSettingsInRegisterFav.IV)}`);
        this.utilServ.uUI.setTitleBar(`${this.authServ.coName} ${this.authServ.empName}様 自動サインインページ`);
        this.isLoading = false;
      }
    );

    // 利用中のブラウザ判定
    const browserName = this.getBrowserName();
    switch (browserName) {
      case 'ChromeIOS':
        $('#browser-tabs a[href="#chromeios-tab"]').tab('show');
        break;
      case 'ChromeAndroid':
        $('#browser-tabs a[href="#chrome-tab"]').tab('show');
        break;
      case 'Safari':
        $('#browser-tabs a[href="#safari-tab"]').tab('show');
        break;
      default:
        $('#browser-tabs a[href="#chromeios-tab"]').tab('show');
        break;
    }
  }

  private getBrowserName(): string {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('chrome') !== -1 && (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1)) {
      return 'ChromeIOS';
    } else if (userAgent.indexOf('chrome') !== -1 && userAgent.indexOf('android')) {
      return 'ChromeAndroid';
    } else if (userAgent.indexOf('safari') !== -1) {
      return 'Safari';
    } else {
      return 'ChromeIOS';
    }
  }

  private async getPasswordAsync(): Promise<string> {
    const password = await this.reqApi.getPassword()
      .catch(err => console.error(err));
    if (!password) {
      throw new Error('could not get valid password.');
    }

    return password;
  }

  public close(): void {
    window.close();
  }
}
